import { render, staticRenderFns } from "./BBBRawFiles.vue?vue&type=template&id=37ee4f30&"
import script from "./BBBRawFiles.vue?vue&type=script&lang=js&"
export * from "./BBBRawFiles.vue?vue&type=script&lang=js&"
import style0 from "./BBBRawFiles.vue?vue&type=style&index=0&id=37ee4f30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports